import { useShop } from './useShop';

/**
 * Feature-flagging by plan tier. Reads plan_limits from the shop context and
 * exposes helpers to gate UI (see PLAN.md §9).
 */
export function usePlan() {
  const { shop } = useShop();
  const limits = (shop?.plan_limits ?? {}) as Record<string, unknown>;

  const has = (feature: string): boolean => Boolean(limits[feature]);

  const limit = (feature: string): number | null => {
    const value = limits[feature];
    return value === null || value === undefined ? null : Number(value);
  };

  return {
    tier: shop?.plan_tier ?? 'free',
    limits,
    has,
    limit,
    isPro: shop?.plan_tier === 'pro',
    isFree: (shop?.plan_tier ?? 'free') === 'free',
  };
}
